// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2eSML","col":"CardReaderDesc_col__3Mq_l","label":"CardReaderDesc_label__1ZRf2"};